import React from 'react';

// Dynamic loaders for React Icons packs
const PACKS = {
  fa: () => import('react-icons/fa'),
  fa6: () => import('react-icons/fa6'),
  md: () => import('react-icons/md'),
  bs: () => import('react-icons/bs'),
  bi: () => import('react-icons/bi'),
  fi: () => import('react-icons/fi'),
  gi: () => import('react-icons/gi'),
  go: () => import('react-icons/go'),
  io: () => import('react-icons/io'),
  io5: () => import('react-icons/io5'),
  ri: () => import('react-icons/ri'),
  si: () => import('react-icons/si'),
  ti: () => import('react-icons/ti'),
  hi: () => import('react-icons/hi'),
  hi2: () => import('react-icons/hi2'),
  sl: () => import('react-icons/sl'),
  im: () => import('react-icons/im'),
  tb: () => import('react-icons/tb'),
  cg: () => import('react-icons/cg'),
  vsc: () => import('react-icons/vsc'),
  rx: () => import('react-icons/rx'),
  pi: () => import('react-icons/pi'),
  lu: () => import('react-icons/lu'),
  tfi: () => import('react-icons/tfi'),
};

const cache = {};

export async function loadPack(pack) {
  if (cache[pack]) return cache[pack];
  const loader = PACKS[pack];
  if (!loader) return null;
  const mod = await loader();
  cache[pack] = mod;
  return mod;
}

export async function getIconComponentByKey(key) {
  if (!key) return null;
  let pack = null;
  let name = null;
  if (key.includes(':')) {
    [pack, name] = key.split(':');
  } else {
    // Try to find the component across packs if no pack is given
    const order = Object.keys(PACKS);
    for (const p of order) {
      const mod = await loadPack(p);
      if (mod && mod[key]) {
        pack = p;
        name = key;
        break;
      }
    }
  }
  if (!pack || !name) return null;
  const mod = await loadPack(pack);
  return mod ? mod[name] : null;
}

export async function listPackIcons(pack) {
  const mod = await loadPack(pack);
  if (!mod) return [];
  return Object.keys(mod).filter((k) => /^[A-Z]/.test(k));
}

export function useIcon(key) {
  const [Comp, setComp] = React.useState(null);
  React.useEffect(() => {
    let alive = true;
    (async () => {
      const ic = await getIconComponentByKey(key);
      if (alive) setComp(() => ic || null);
    })();
    return () => { alive = false; };
  }, [key]);
  return Comp;
}